import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const KalkylatorPage = lazy(() => import("@/pages/kalkylatorer/KalkylatorPage"));

export const Route = createFileRoute("/batterier/batterikalkylator")({
  head: () => seoHead("/batterier/batterikalkylator", { description: "Räkna ut hur mycket el solceller kan producera på ditt tak, vad elen är värd per år och hur lång återbetalningstiden blir." }),
  component: () => <KalkylatorPage kind="batterier" />,
});
